/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sign_OutInputs */

const en_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const es_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const de_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const zh_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出登录`)
};

const ar_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الخروج`)
};

const fr_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const vi_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng xuất`)
};

const sw_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toka`)
};

const th_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกจากระบบ`)
};

const bs_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odjava`)
};

const ja_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

const ko_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃`)
};

const pt_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const it_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

const sv_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga ut`)
};

const nl_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afmelden`)
};

const da_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ud`)
};

const nb_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg ut`)
};

const fi_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu ulos`)
};

const pl_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyloguj się`)
};

const ru_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти`)
};

const tr_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış yap`)
};

const hi_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग आउट`)
};

const id_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar`)
};

const ms_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log keluar`)
};

const cs_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odhlásit se`)
};

const el_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποσύνδεση`)
};

const he_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התנתקו`)
};

const af_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teken uit`)
};

const hu_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kijelentkezés`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Nav_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_sign_out = /** @type {((inputs?: Nav_Sign_OutInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sign_OutInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_sign_out(inputs)
	if (locale === "de") return de_nav_sign_out(inputs)
	if (locale === "zh") return zh_nav_sign_out(inputs)
	if (locale === "ar") return ar_nav_sign_out(inputs)
	if (locale === "fr") return fr_nav_sign_out(inputs)
	if (locale === "vi") return vi_nav_sign_out(inputs)
	if (locale === "sw") return sw_nav_sign_out(inputs)
	if (locale === "th") return th_nav_sign_out(inputs)
	if (locale === "bs") return bs_nav_sign_out(inputs)
	if (locale === "ja") return ja_nav_sign_out(inputs)
	if (locale === "ko") return ko_nav_sign_out(inputs)
	if (locale === "pt") return pt_nav_sign_out(inputs)
	if (locale === "it") return it_nav_sign_out(inputs)
	if (locale === "sv") return sv_nav_sign_out(inputs)
	if (locale === "nl") return nl_nav_sign_out(inputs)
	if (locale === "da") return da_nav_sign_out(inputs)
	if (locale === "nb") return nb_nav_sign_out(inputs)
	if (locale === "fi") return fi_nav_sign_out(inputs)
	if (locale === "pl") return pl_nav_sign_out(inputs)
	if (locale === "ru") return ru_nav_sign_out(inputs)
	if (locale === "tr") return tr_nav_sign_out(inputs)
	if (locale === "hi") return hi_nav_sign_out(inputs)
	if (locale === "id") return id_nav_sign_out(inputs)
	if (locale === "ms") return ms_nav_sign_out(inputs)
	if (locale === "cs") return cs_nav_sign_out(inputs)
	if (locale === "el") return el_nav_sign_out(inputs)
	if (locale === "he") return he_nav_sign_out(inputs)
	if (locale === "af") return af_nav_sign_out(inputs)
	if (locale === "hu") return hu_nav_sign_out(inputs)
	return en_nav_sign_out(inputs)
});